export default {
    columns: [
        {
          type: "NUMERIC",
          desc: "Código interno del proyecto",
          label: "Código proyecto",
          field: "id"
        },
		{
          type: "CHARACTER",
          desc: "Nombre del proyecto",
          label: "Nombre proyecto",
          field: "shortName"
        },
		{
          type: "CHARACTER",
          desc: "Descripción del proyecto",
          label: "Desc. proyecto",
          field: "description"
        },
		{
          type: "CHARACTER",
          desc: "Referencia externa del proyecto",
          label: "Referencia proyecto",
          field: "internalCode"
        },
        {
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.procedure.from-date.description",//"Fecha inicial indicada en la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.from-date.text",//"Fecha inicial",
          field: "fromDate",
          formatter: "formatSimpleDate"
        },
        {
          type: "SIMPLEDATE",
          desc: "wkt.admin.qbuilder.model.procedure.to-date.description",//"Fecha final indicada en la solicitud",
          label: "wkt.admin.qbuilder.model.procedure.to-date.text",//"Fecha final",
          field: "toDate",
          formatter: "formatSimpleDate"
        },
        {
          field: "enabled",
          type: "NUMERIC",
          desc: "Proyecto habilitado",
          label: "Proyecto habilitado",
          formatter: 'formatChoice',
          choices: [ { 'key':'0', 'value':'wkt.admin.common.no'/*'NO'*/ },
                     { 'key':'1', 'value':'wkt.admin.common.yes'/*'SI'*/ } ]
        }
      ],
}